import { ContentBlock } from '@layouts/ContentBlocks';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import theme from '@ui/theme';
import Link from 'next/link';
import React from 'react';

import { CTAButton } from '../buttons/CTAButton';
import useStyles from './HowItWorks.style';

const HowItWorks = () => {
  const { md } = useBreakpoints();
  const { classes } = useStyles();

  return (
    <ContentBlock
      padding={md ? [15, 0, 15, 0] : [4, 0]}
      style={{ backgroundColor: '#E9E6E3' }}
      margin={[0]}
      maxWidth={'none'}
    >
      <ContentBlock
        maxWidth={1308}
        margin={[0, 'auto']}
      >
        <Box
          display={md ? 'flex' : 'block'}
          alignItems="flex-start"
          justifyContent="center"
          gap={10}
          sx={{
            '& a': {
              textDecoration: 'none !important'
            }
          }}
        >
          <Box
            flex={1}
            sx={{
              marginBottom: md ? 0 : '32px',
            }}
          >
            <Typography
              fontFamily={theme.gh_vars.circular}
              variant="h2"
              style={{ fontSize: md ? 48 : 24, letterSpacing: '-2%', marginBottom: md ? '24px' : '16px' }}
            >
              How it works
            </Typography>
             
            <CTAButton
              href="/home-staging/get-a-quote"
              label="Get started"
              color="primary"
            />
          </Box>
          <Box flex={2}>
            <Box
              className={classes.partnerStep}
              sx={{ borderBottom: '1px solid #080808' }}
            >
              <Box >
                <Typography
                  variant="h2"
                  component="p"
                  style={{ fontSize: md ? 60 : 24, letterSpacing: '-2%px', marginBottom: md ? '24px' : 0, fontWeight: 450 }}
                >
                  1
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h3"
                  component="p"
                  style={{ fontSize: md ? 24 : 18, marginBottom: '16px', marginTop: md ? '20px' : '10px' }}
                >
                  Get a quote & book instantly
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  style={{ fontSize: md ? 18 : 18, lineHeight: 1.4 }}
                >
                  We make it easy to book and schedule market-ready services instantly. Checkout with credit card or 
                  {' '}
                  <Link href="/affirm">
                    pay over time with Affirm
                  </Link>
                  .
                </Typography>
              </Box>
            </Box>
            <Box
              className={classes.partnerStep}
              sx={{ borderBottom: '1px solid #080808' }}
            >
              <Box >
                <Typography
                  variant="h2"
                  component="p"
                  style={{ fontSize: md ? 60 : 24, letterSpacing: '-2%px', marginBottom: md ? '24px' : 0, fontWeight: 450 }}
                >
                  2
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h3"
                  component="p"
                  style={{ fontSize: md ? 24 : 18, marginBottom: '16px', marginTop: md ? '20px' : '10px' }}
                >
                  We deliver in as soon as 3 days
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  style={{ fontSize: md ? 18 : 18, lineHeight: 1.4 }}
                >
                  Let our team do all of the legwork – from touring the space to styling the last throw pillow.
                </Typography>
              </Box>
            </Box>
            <Box
              className={classes.partnerStep}
            >
              <Box >
                <Typography
                  variant="h2"
                  component="p"
                  style={{ fontSize: md ? 60 : 24, letterSpacing: '-2%px', marginBottom: md ? '24px' : 0, fontWeight: 450 }}
                >
                  3
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h3"
                  component="p"
                  style={{ fontSize: md ? 24 : 18, marginBottom: '16px', marginTop: md ? '20px' : '10px' }}
                >
                  De-install anytime
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  style={{ fontSize: md ? 18 : 18, lineHeight: 1.4 }}
                >
                  When you&apos;re ready to remove staging, give us at least 5 days notice and we&apos;ll pick it up.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </ContentBlock>
    </ContentBlock>
  );
};

export default HowItWorks;
